export enum LandingCategory {
  MyPartners = 'jbp-my-partners',
  RequestPartners = 'jbp-request-partners',
  TopBpsPartners = 'jbp-top-bps-partners',
  TopOpsPartners = 'jbp-top-ops-partners',
  TopPartners = 'jbp-top-partners',
  StrategicMpsPartners = 'jbp-strategic-mps-partners',
  MpsPartners = 'jbp-mps-partners',
  StrategicPrintServicesPartners = 'jbp-strategic-print-services-partners',
  PrintServicesPartners = 'jbp-print-services-partners',
  StrategicPsServicesPartners = 'jbp-strategic-ps-services-partners',
  PsServicesPartners = 'jbp-ps-services-partners',
  StrategicPolyPartners = 'jbp-strategic-poly-partners',
  PolyPartners = 'jbp-poly-partners',
  MdfPartner = 'jbp-mdf-partners',
}
